// modules/basic/wrapper/index.tsx
import React from 'react';
import './styles.css';
import Header from '../header';
import Footer from '../footer';
import FooterMobile from '../footer-mobile';
import { COLORS } from '../../../constants/texts';

interface Props {
    children: JSX.Element;
    color?: string;
    hasFooter?: boolean;
    footerColor?: string;
    bgImage?: string;
    logoColor?: string;
}

const Wrapper: React.FC<Props> = ({
    children,
    color = COLORS.WHITE,
    hasFooter = true,
    footerColor = COLORS.BLACK,
    bgImage = null,
    logoColor = COLORS.BLACK,
}) => {
    const [showHeader, setShowHeader] = React.useState(true);
    const lastScrollRef = React.useRef(0);
    const wrapperRef = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => {
        const el = wrapperRef.current;
        if (!el) return;
    
        const handleScroll = () => {
            const currentY = el.scrollTop;
            const prevY = lastScrollRef.current;
    
            // Always show when near the very top
            if (currentY <= 10) {
                if (!showHeader) setShowHeader(true);
            } else {
                if (currentY > prevY) {
                    // scrolling down
                    if (showHeader) setShowHeader(false);
                } else if (currentY < prevY) {
                    // scrolling up
                    if (!showHeader) setShowHeader(true);
                }
            }
    
            // store current position for next event
            lastScrollRef.current = currentY < 0 ? 0 : currentY;
        };
    
        el.addEventListener('scroll', handleScroll);
        return () => {
            el.removeEventListener('scroll', handleScroll);
        };
    }, [showHeader]);
    


    return (
        <div
            ref={wrapperRef}
            className='wrapper'
            style={{
                backgroundColor: color,
                backgroundImage: bgImage ? `url(${bgImage})` : 'none',
            }}
        >
            <Header color={color} logoColor={logoColor} isVisible={showHeader} />
            <div className='wrapper-children'>{children}</div>
            {hasFooter && <Footer />}
            {hasFooter && <FooterMobile />}
        </div>
    );
};

export default Wrapper;
